function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAAA IDP Completed Payment page
 * 
 */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ErrorApp from '../../components/error-app/ErrorApp';
import ConfirmationTable from './confirmation-table/ConfirmationTable';
import NextSteps from './next-steps/NextSteps';
import Footer from './footer/Footer';
import { Link } from 'react-router-dom';
import { clubDomain } from '../../data/Data';
import { SITE_CONTENT } from '../../reducers/content/Site.content';
import { trackPurchase } from '../../utils/metaPixel';
import { pushPurchaseEvent } from '../../utils/dataLayer';
import './Confirmation.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Confirmation extends Component {
  constructor(props) {
    super(props);
    /**
     * Track purchase event via Meta Pixel (loaded via GTM)
     */
    _defineProperty(this, "pushMetaPurchaseEvent", () => {
      const {
        id,
        paymentAmount,
        receiptNumber
      } = this.state;

      // Use order id as event_id to deduplicate with CAPI
      // Falls back to receiptNumber if order id not available
      trackPurchase({
        transactionId: id || receiptNumber,
        value: parseFloat(paymentAmount || '0') || 0,
        currency: 'AUD',
        contentName: 'International Driving Permit'
      });
    });
    /**
     * Push Google Analytics purchase event.
     */
    _defineProperty(this, "pushGaPurchaseEvent", () => {
      const {
        id,
        paymentAmount,
        postageDescription
      } = this.state;
      const {
        hostname
      } = window.location;
      const club = clubDomain(hostname);
      pushPurchaseEvent({
        transaction_id: id,
        value: parseFloat(paymentAmount || '0'),
        club: club,
        delivery_method: postageDescription || ''
      });
    });
    const {
      search
    } = props.location;
    const params = new URLSearchParams(search);
    const _id = params.get('id');
    const createdDateTime = params.get('createdDateTime');
    const submission_token = params.get('submission_token');
    const _paymentAmount = params.get('paymentAmount');
    const _postageDescription = params.get('postageDescription');
    const _receiptNumber = params.get('receiptNumber');
    const responseDescription = params.get('responseDescription');
    const status = params.get('status');
    const apiSuccess = params.get('apiSuccess');
    this.state = {
      apiSuccess,
      createdDateTime,
      id: _id,
      paymentAmount: _paymentAmount,
      postageDescription: _postageDescription,
      receiptNumber: _receiptNumber,
      responseDescription,
      spinner: true,
      status,
      submission_token
    };
  }
  componentDidMount() {
    const {
      apiSuccess,
      id,
      status
    } = this.state;
    // Success is the default case in render() - fires when:
    // - status is not 'fail' (payment didn't fail)
    // - AND not (status === 'sent' && apiSuccess === 'false') (API didn't fail after payment)
    const isSuccess = id && status !== 'fail' && !(status === 'sent' && apiSuccess === 'false');
    if (!isSuccess || !id) {
      return;
    }
    this.pushMetaPurchaseEvent();
    this.pushGaPurchaseEvent();
  }
  render() {
    const {
      bugsnagClient,
      content
    } = this.props;
    const {
      hostname
    } = window.location;
    const {
      apiSuccess,
      createdDateTime,
      id,
      paymentAmount,
      postageDescription,
      responseDescription,
      status,
      submission_token
    } = this.state;
    const {
      nextSteps
    } = content;
    const club = clubDomain(hostname);

    // http://racq.idp.local:3000/confirmation?createdDateTime=2021-07-22+12%3A17%3A54&id=740&submission_token=6LN2emhmhB&apiSuccess=true&status=fail&paymentAmount=51.00&postageDescription=Express+Post+within+Australia&responseDescription=Declined
    switch (true) {
      case !id || !submission_token:
        return /*#__PURE__*/_jsx(ErrorApp, {
          bugsnagClient: bugsnagClient
        });
      case status === 'sent' && apiSuccess === 'false':
        return /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsxs("section", {
            className: "content-container Confirmation",
            children: [/*#__PURE__*/_jsx("h2", {
              children: "Your payment was successful"
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsxs("p", {
                className: "error",
                children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                  icon: "triangle-exclamation"
                }), "There was an error with your payment."]
              }), /*#__PURE__*/_jsxs("p", {
                className: "error",
                children: ["Please contact ", club, " to confirm your order."]
              }), /*#__PURE__*/_jsx(ConfirmationTable, {
                ...this.props,
                createdDateTime: createdDateTime,
                id: id,
                paymentAmount: paymentAmount,
                postageDescription: postageDescription
              })]
            }), /*#__PURE__*/_jsx(Footer, {
              apiSuccess: apiSuccess,
              status: status
            })]
          })
        });
      case status === 'fail' && apiSuccess === 'true':
        return /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsxs("section", {
            className: "content-container Confirmation",
            children: [/*#__PURE__*/_jsx("h2", {
              children: "Your payment was unsuccessful"
            }), /*#__PURE__*/_jsxs("div", {
              children: [responseDescription ? /*#__PURE__*/_jsxs("p", {
                className: "error",
                children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
                  icon: "triangle-exclamation"
                }), responseDescription]
              }) : null, /*#__PURE__*/_jsxs("p", {
                children: ["Please confirm the details and ", /*#__PURE__*/_jsx(Link, {
                  to: "/payment",
                  children: "try payment again"
                })]
              })]
            }), /*#__PURE__*/_jsx(Footer, {
              apiSuccess: apiSuccess,
              status: status
            })]
          })
        });
      default:
        return /*#__PURE__*/_jsx(Fragment, {
          children: /*#__PURE__*/_jsxs("section", {
            className: "content-container Confirmation",
            children: [/*#__PURE__*/_jsx("h2", {
              children: "Thanks for your application."
            }), /*#__PURE__*/_jsxs("p", {
              children: ["Your order number is ", id, ". Please use this reference in any future correspondence. You will receive a confirmation email shortly confirming your application has been received."]
            }), /*#__PURE__*/_jsx(ConfirmationTable, {
              ...this.props,
              createdDateTime: createdDateTime,
              id: id,
              paymentAmount: paymentAmount,
              postageDescription: postageDescription
            }), /*#__PURE__*/_jsx("h2", {
              children: nextSteps.title
            }), /*#__PURE__*/_jsx(NextSteps, {
              ...nextSteps,
              postageDescription: postageDescription
            }), /*#__PURE__*/_jsx(Footer, {
              apiSuccess: apiSuccess,
              status: status
            })]
          })
        });
    }
  }
}
_defineProperty(Confirmation, "defaultProps", {
  content: {
    ...SITE_CONTENT
  },
  location: {
    search: ''
  }
});
export default withRouter(Confirmation);